const POST_LOGIN_REDIRECT_KEY = 'APP_POST_LOGIN_REDIRECT';

export const getCurrentAppPath = () => {
  if (typeof window === 'undefined') return '/';
  const { pathname, search, hash } = window.location;
  return `${pathname || '/'}${search || ''}${hash || ''}`;
};

export const savePostLoginRedirect = (path = getCurrentAppPath()) => {
  if (typeof window === 'undefined') return;
  if (!path || path.startsWith('/login')) return;
  sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
};

export const readPostLoginRedirect = () => {
  if (typeof window === 'undefined') return '';
  return sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY) || '';
};

export const clearPostLoginRedirect = () => {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
};

export const buildLoginUrl = (path = getCurrentAppPath()) => {
  const redirectPath = path && !path.startsWith('/login') ? path : '';
  return redirectPath ? `/login?redirect=${encodeURIComponent(redirectPath)}` : '/login';
};
